function getInitialState() {
  const stepTitles = ['Basisdaten', 'Produktauswahl', 'Persönliche Daten', 'Vertragsdaten', 'Abschluss'];
  return {
    privat: {
      steps: stepTitles.map((title, index) => {
        const stepNumber = index + 1;
        return {
          number: stepNumber,
          name: `step${stepNumber}`,
          complete: false,
          component: `PrivatStep${stepNumber}`,
          title
        };
      }),
      activeStepNumber: 1
    },
    aenderung: {
      steps: stepTitles.map((title, index) => {
        const stepNumber = index + 1;
        return {
          number: stepNumber,
          name: `step${stepNumber}`,
          complete: false,
          component: `PrivatStep${stepNumber}`,
          title
        };
      }),
      activeStepNumber: 1
    },
    gewerbe: {
      steps: stepTitles.map((title, index) => {
        const stepNumber = index + 1;
        return {
          number: stepNumber,
          name: `step${stepNumber}`,
          complete: false,
          component: `GewerbeStep${stepNumber}`,
          title
        };
      }),
      activeStepNumber: 1
    },
    windowinnerwidth: window.innerWidth,
    breakpointwidth: 0
  };
}

//actions
const actions = {};

// mutations
const mutations = {

  resetSteps(state, {page}) {
    Object.assign(state[page], (getInitialState())[page]);
  },

  doStepTo(state, payload) {
    state[payload.page].activeStepNumber = payload.stepNumber;
  },

  setStepComplete(state, payload) {
    state[payload.page].steps[payload.stepNumber - 1].complete = true;
  },
};

const getters = {
  activeStepNumberPrivat: (state) => {
    return state.privat.activeStepNumber;
  },
  activeStepNumberAenderung: (state) => {
    return state.aenderung.activeStepNumber;
  },
  reactivWindowWidth: (state) => {
    return state.windowinnerwidth;
  },
};

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations
};
